<template>
  <div class="sidebar" id="sidebar">
    <div class="sidebar-inner" id="style-15">
      <vue-custom-scrollbar
        class="scroll-area"
        :settings="settings"
        @ps-scroll-x="scrollHanle"
      >
        <div id="sidebar-menu" class="sidebar-menu">
          <ul>
            <router-link
              v-if="role == userRoleSuperAdmin || role == userRoleAdmin"
              :to="{ name: 'adminMerchantList' }"
              tag="li"
              :class="
                $route.path.includes('/merchant') &&
                !$route.path.includes('/merchantuser')
                  ? activeClass
                  : ''
              "
            >
              <a><i class="la la-industry"></i><span>Merchants</span></a>
            </router-link>
            <router-link
              v-if="
                role == userRoleSuperAdmin ||
                role == userRoleAdmin ||
                role == userRoleMerchantAdmin
              "
              :to="{
                name:
                  role == userRoleSuperAdmin || role == userRoleAdmin
                    ? 'adminMerchantUserList'
                    : 'merchantMerchantUserList',
              }"
              tag="li"
              :class="$route.path.includes('/merchantuser') ? activeClass : ''"
            >
              <a><i class="la la-user-plus"></i><span>Merchant Users</span></a>
            </router-link>
            <!-- <router-link
              :to="{
                name:
                  role == userRoleSuperAdmin || role == userRoleAdmin
                    ? 'adminCustomerList'
                    : 'merchantCustomerList',
              }"
              tag="li"
              :class="$route.path.includes('/customer') ? activeClass : ''"
            >
              <a><i class="la la-user-friends"></i><span>Customers</span></a>
            </router-link> -->

            <li class="submenu">
              <a>
                <i class="la la-tag"></i>
                <span>E-Coupon</span>
                <span class="menu-arrow"></span>
              </a>
              <ul style="display: none">
                <router-link
                  v-if="role == userRoleSuperAdmin || role == userRoleAdmin"
                  :to="{ name: 'merchantApiDoc' }"
                  tag="li"
                  :class="$route.path.includes('/apidoc') ? activeClass : ''"
                >
                  <a>
                    <i class="la la-book"></i>
                    <span class="ml-0">API Documentation</span>
                  </a>
                </router-link>
                <router-link
                  v-if="
                    this.allowBatchEcoupon && 
                    (role == userRoleSuperAdmin ||
                    role == userRoleAdmin ||
                    role == userRoleMerchantAdmin)
                  "
                  :to="{
                    name:
                      role == userRoleSuperAdmin || role == userRoleAdmin
                        ? 'adminBatchEcouponList'
                        : 'merchantBatchEcouponList',
                  }"
                  tag="li"
                  :class="
                    $route.path.includes('/batchecoupon') ? activeClass : ''
                  "
                >
                  <a>
                    <i class="la la-tags"></i>
                    <span class="ml-0">Batch E-Coupons Upload</span>
                  </a>
                </router-link>

                <router-link
                  v-if="
                    this.allowBatchEcoupon && 
                    role == userRoleMerchantAdmin
                  "
                  :to="{
                    name: 'merchantBatchEcouponReminder',
                  }"
                  tag="li"
                  :class="
                    $route.path.includes('/batch-ecouponreminder') ? activeClass : ''
                  "
                >
                  <a>
                    <i class="la la-tags"></i>
                    <span class="ml-0">Batch E-Coupons<br />Reminder</span>
                  </a>
                </router-link>

                <router-link
                  v-if="
                    this.allowFlexibleEcoupon && 
                    (role == userRoleSuperAdmin ||
                    role == userRoleAdmin ||
                    role == userRoleMerchantAdmin)
                  "
                  :to="{
                    name:
                      role == userRoleSuperAdmin || role == userRoleAdmin
                        ? 'adminFlexibleEcouponList'
                        : 'merchantFlexibleEcouponList',
                  }"
                  tag="li"
                  :class="
                    $route.path.includes('/flexibleecoupon') ? activeClass : ''
                  "
                >
                  <a>
                    <i class="la la-gift"></i>
                    <span class="ml-0">Flexible E-Coupons</span>
                  </a>
                </router-link>

                <router-link
                  v-if="
                    (role == userRoleSuperAdmin ||
                    role == userRoleAdmin)
                  "
                  :to="{
                    name: 'adminEcouponUsageReport'
                  }"
                  tag="li"
                  :class="$route.path.includes('/ecoupon/usage-report') ? activeClass : ''"
                >
                  <a><i class="la la-file-alt"></i><span>Report</span></a>
                </router-link>

                <router-link
                  v-if="
                    this.allowRedemption && 
                    (role == userRoleMerchantAdmin ||
                    role == userRoleMerchantUser)
                  "
                  :to="{ name: 'merchantRedemptionPin' }"
                  tag="li"
                  :class="
                    $route.path.includes('/redemptionpin') ? activeClass : ''
                  "
                >
                  <a>
                    <i class="la la-key"></i>
                    <span class="ml-0">Redemption PIN Code</span>
                  </a>
                </router-link>
                <router-link
                  v-if="
                    this.allowRedemption && 
                    (role == userRoleMerchantAdmin ||
                    role == userRoleMerchantUser)
                  "
                  :to="{ name: 'merchantRedeem' }"
                  tag="li"
                  :class="$route.path.includes('/redeem') ? activeClass : ''"
                >
                  <a>
                    <i class="la la-sign-in-alt"></i>
                    <span class="ml-0">Redeem E-Coupon</span>
                  </a>
                </router-link>

                <!-- <router-link
                  v-if="
                    this.allowVoid && 
                    (role == userRoleMerchantAdmin ||
                    role == userRoleMerchantUser)
                  "
                  :to="{ name: 'merchantVoid' }"
                  tag="li"
                  :class="$route.path.includes('/void') ? activeClass : ''"
                >
                  <a>
                    <i class="la la-sign-in-alt"></i>
                    <span class="ml-0">Void E-Coupon</span>
                  </a>
                </router-link> -->
              </ul>
            </li>

            <!-- <router-link
              v-if="
                role == userRoleSuperAdmin ||
                role == userRoleAdmin ||
                role == userRoleMerchantAdmin
              "
              :to="{
                name:
                  role == userRoleSuperAdmin || role == userRoleAdmin
                    ? 'adminEcouponList'
                    : 'merchantEcouponList',
              }"
              tag="li"
              :class="$route.path.includes('/ecoupon') ? activeClass : ''"
            >
              <a><i class="la la-tag"></i><span>E-Coupons</span></a>
            </router-link> -->
            <!-- <router-link
              v-if="
                this.allowReport &&
                (role == userRoleSuperAdmin ||
                role == userRoleAdmin ||
                role == userRoleMerchantAdmin)
              "
              :to="{
                name:
                  role == userRoleSuperAdmin || role == userRoleAdmin
                    ? 'adminReport'
                    : 'merchantReport',
              }"
              tag="li"
              :class="$route.path.includes('/report') ? activeClass : ''"
            >
              <a><i class="la la-file-alt"></i><span>Report</span></a>
            </router-link> -->

            <router-link
              v-if="role == userRoleSuperAdmin"
              :to="{ name: 'adminUserList' }"
              tag="li"
              :class="$route.path.includes('/adminuser') ? activeClass : ''"
            >
              <a><i class="la la-user-cog"></i><span>Admin Users</span></a>
            </router-link>
            <router-link
              v-if="role == userRoleSuperAdmin"
              :to="{ name: 'adminAuditLog' }"
              tag="li"
              :class="$route.path.includes('/auditlog') ? activeClass : ''"
            >
              <a><i class="la la-history"></i><span>Audit Log</span></a>
            </router-link>
          </ul>
        </div>
      </vue-custom-scrollbar>
    </div>
  </div>
</template>
  
<script>
import config from "../../config.js";
import vueCustomScrollbar from "vue-custom-scrollbar";
import "vue-custom-scrollbar/dist/vueScrollbar.css";

export default {
  components: {
    vueCustomScrollbar,
  },
  data() {
    let data = JSON.parse(localStorage.getItem("emstoken"));

    return {
      settings: {
        suppressScrollX: false,
      },
      activeClass: "active",
      userRoleSuperAdmin: config.USER_ROLE_SUPER_ADMIN,
      userRoleAdmin: config.USER_ROLE_ADMIN,
      userRoleMerchantAdmin: config.USER_ROLE_MERCHANT_ADMIN,
      userRoleMerchantUser: config.USER_ROLE_MERCHANT_USER,
      allowPinRedemption: data.allow_pin_redemption,
      allowBatchEcoupon: data.allow_batch_ecoupon,
      allowFlexibleEcoupon: data.allow_flexible_ecoupon,
      allowReport: (this.role == config.USER_ROLE_SUPER_ADMIN || this.role == config.USER_ROLE_ADMIN) ? true : data.allow_report,
      allowVoid: data.allow_void ? data.allow_void : true
    };
  },
  computed: {
    role() {
      let data = JSON.parse(localStorage.getItem("emstoken"));
      return data ? data.role : null;
    },
  },
  methods: {
    scrollHanle(evt) {
      console.log(evt);
    },
  },

  mounted() {
    $(document).on("click", "#sidebar-menu a", function (e) {
      if ($(this).parent().hasClass("submenu")) {
        e.preventDefault();
      }
      if (!$(this).hasClass("subdrop")) {
        $("ul", $(this).parents("ul:first")).slideUp(350);
        $("a", $(this).parents("ul:first")).removeClass("subdrop");
        $(this).next("ul").slideDown(350);
        $(this).addClass("subdrop");
      } else if ($(this).hasClass("subdrop")) {
        $(this).removeClass("subdrop");
        $(this).next("ul").slideUp(350);
      }
    });

    //expand any active link on initial load
    window.setTimeout(() => {
      $("#sidebar-menu ul li.active a")
        .parents("li:last")
        .children("a:first")
        .addClass("active")
        .trigger("click");
    }, 500);
  },
};
</script>
  
  <style scoped>
.scroll-area {
  position: relative;
  margin: auto;
  height: calc(100vh - 60px);
  background-color: transparent !important;
}

.sidebar {
  width: 245px;
}

.slide-nav .sidebar {
  margin-left: 0;
}

@media only screen and (min-width: 991px) {
  .mini-sidebar .sidebar {
    width: 60px;
  }
  .mini-sidebar.expand-menu .sidebar {
    width: 245px;
  }
}

@media only screen and (max-width: 991.98px) {
  .sidebar {
    margin-left: -245px;
    width: 245px;
  }
}
</style>
  
  


// WEBPACK FOOTER //
// src/components/Layout/Sidebar.vue